import { render, staticRenderFns } from "./ConfigSelectEgdsLavaggioDisinfezioneList.vue?vue&type=template&id=14dde7b4"
import script from "./ConfigSelectEgdsLavaggioDisinfezioneList.vue?vue&type=script&lang=js"
export * from "./ConfigSelectEgdsLavaggioDisinfezioneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports